module.exports = __webpack_public_path__ + "img/dsaj_icon.74aeb585.png";